// German category labels.
export const HELP_CATEGORIES = [
  { id: 'getting-started', label: 'Erste Schritte', icon: '🚀' },
  { id: 'data', label: 'Daten vorbereiten & hochladen', icon: '📁' },
  { id: 'analysis', label: 'Eine Analyse ausführen', icon: '▶️' },
  { id: 'results', label: 'Ergebnisse verstehen', icon: '📊' },
  { id: 'troubleshooting', label: 'Fehlerbehebung', icon: '🛠️' },
]
